import React from 'react'

import { useFormContext } from 'react-hook-form'

import { DatetimePicker, FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Trades } from '@fortem-monorepo/web-sdk'

export interface TradeDatetimeFormFieldProps {}

const _TradeDatetimeFormField: React.FC<TradeDatetimeFormFieldProps> = ({}) => {
  const { control } = useFormContext<Trades.BookTradeBody>()

  return (
    <FormField
      name="trade_datetime_utc"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Trade Datetime</FormLabel>
              <FormError />
            </div>
            <DatetimePicker
              defaultTime={{ hours: 12 }}
              selected={field.value ? new Date(field.value) : undefined}
              onSelect={(date) => {
                field.onChange(date ? date.toISOString() : '')
              }}
            />
          </FormItem>
        )
      }}
    />
  )
}

export const TradeDatetimeFormField = React.memo(_TradeDatetimeFormField)
